module.exports = __webpack_public_path__ + "ac977ed412b071c9c508dfd8a4f39a60.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/reports/group-8-copy-2.svg
// module id = 942
// module chunks = 0